import { useWorkspaceStore } from '@/stores/workspaceStore'
import { DashboardMode } from './modes/DashboardMode'
import { FullAIAssistantMode } from './modes/FullAIAssistantMode'
import { CanvasMode } from './modes/CanvasMode'
import { SmartDocMode } from './modes/SmartDocMode'
import { EntitiesMode } from './modes/EntitiesMode'
import { FlowMode } from './modes/FlowMode'

interface WorkspaceModeRendererProps {
  onViewChange?: (view: string) => void
}

export function WorkspaceModeRenderer({ onViewChange }: WorkspaceModeRendererProps) {
  const { activeMode, workspaceContext } = useWorkspaceStore()

  return (
    <div className="h-full w-full">
      {activeMode === 'dashboard' && (
        <DashboardMode
          context={workspaceContext}
          onViewChange={onViewChange}
        />
      )}
      {activeMode === 'full-ai' && (
        <FullAIAssistantMode context={workspaceContext} />
      )}
      {activeMode === 'canvas' && <CanvasMode context={workspaceContext} />}
      {activeMode === 'smart-doc' && (
        <SmartDocMode context={workspaceContext} />
      )}
      {activeMode === 'entities' && <EntitiesMode context={workspaceContext} />}
      {activeMode === 'flow' && <FlowMode context={workspaceContext} />}
    </div>
  )
}
